@if (showMenu) {
  <div class="side-menu-settings">
    <button mat-button [matMenuTriggerFor]="menu" class="side-menu-settings-button" data-test="mega-menu-trigger">
      <span class="side-menu-settings-content">
        <mat-icon class="settings-icon">settings</mat-icon>
        <span class="settings-title">{{ "settings.account.navigation.my-triggerbee" | translate }}</span>
      </span>
    </button>
    <mat-menu #menu="matMenu" class="mega-menu" backdropClass="mega-menu-wrapper" (closed)="showedSubMenu = ''" xPosition="after" yPosition="above">
      <div class="mega-menu-links">
        <div class="settings-menu">
          <h3>{{ "settings.account.new-title" | translate }}</h3>
          <!-- account settings -->
          <a
            href
            mat-menu-item
            (click)="emitCloseSideMenu()"
            [routerLink]="isSiteAdmin ? '/settings/general' : null"
            class="mega-menu-navigation-item"
            [disabled]="!isSiteAdmin"
            [class.disabled]="!isSiteAdmin">
            <div class="icon"><mat-icon class="tb-icon" svgIcon="tb:settings"></mat-icon></div>
            {{ "settings.account.navigation.general" | translate }}
          </a>
          <!-- customization -->
          <a
            href
            mat-menu-item
            class="mega-menu-navigation-item"
            [routerLink]="isSiteAdmin ? '/settings/customization' : null"
            [disabled]="!isSiteAdmin"
            [class.disabled]="!isSiteAdmin">
            <div class="icon"><mat-icon class="tb-icon" svgIcon="tb:customization"></mat-icon></div>
            {{ "settings.account.navigation.customization" | translate }}
          </a>
          @if (currentDevice === detectedDevice.Mobile) {
            <div class="sub-menu-wrapper-mobile">
              <a
                href
                mat-menu-item
                (click)="emitCloseSideMenu()"
                [routerLink]="isSiteAdmin ? '/settings/customization' : null"
                class="mega-menu-navigation-item"
                [disabled]="!isSiteAdmin"
                [class.disabled]="!isSiteAdmin">
                {{ "settings.account.navigation.brand-settings" | translate }}
              </a>
              <a href mat-menu-item (click)="emitCloseSideMenu()" [routerLink]="'/settings/content-popularity'" class="mega-menu-navigation-item">
                {{ "settings.dimensions.title" | translate }}
              </a>
              <a
                href
                mat-menu-item
                (click)="emitCloseSideMenu()"
                [routerLink]="isSiteAdmin ? '/settings/events' : null"
                class="mega-menu-navigation-item"
                [disabled]="!isSiteAdmin"
                [class.disabled]="!isSiteAdmin">
                {{ "settings.event.title" | translate }}
              </a>
              <a
                href
                mat-menu-item
                (click)="emitCloseSideMenu()"
                [routerLink]="isSiteAdmin ? '/settings/placeholders' : null"
                class="mega-menu-navigation-item"
                [disabled]="!isSiteAdmin"
                [class.disabled]="!isSiteAdmin">
                {{ "settings.account.navigation.onsite-campaign" | translate }}
              </a>
              <a
                href
                mat-menu-item
                (click)="emitCloseSideMenu()"
                [routerLink]="isSiteAdmin ? '/settings/policy' : null"
                class="mega-menu-navigation-item"
                [disabled]="!isSiteAdmin"
                [class.disabled]="!isSiteAdmin">
                {{ "consent.welcome.title" | translate }}
              </a>
              <a
                href
                mat-menu-item
                (click)="emitCloseSideMenu()"
                [routerLink]="isSiteAdmin ? '/settings/contact-fields' : null"
                class="mega-menu-navigation-item"
                [disabled]="!isSiteAdmin"
                [class.disabled]="!isSiteAdmin">
                {{ "settings.account.navigation.profile-properties" | translate }}
              </a>
              <a
                href
                mat-menu-item
                (click)="emitCloseSideMenu()"
                [routerLink]="isSiteAdmin ? '/settings/revenue' : null"
                class="mega-menu-navigation-item"
                [disabled]="!isSiteAdmin"
                [class.disabled]="!isSiteAdmin">
                {{ "settings.account.revenue.title" | translate }}
              </a>
            </div>
          }
          <!-- my-user -->
          <a href mat-menu-item (click)="emitCloseSideMenu()" [routerLink]="'/settings/profile'" class="mega-menu-navigation-item">
            <div class="icon"><mat-icon class="tb-icon" svgIcon="tb:user"></mat-icon></div>
            {{ "settings.account.navigation.profile" | translate }}
          </a>
          <a
            href
            mat-menu-item
            (click)="emitCloseSideMenu()"
            [routerLink]="isSiteAdmin ? '/settings/users' : null"
            class="mega-menu-navigation-item"
            [disabled]="!isSiteAdmin"
            [class.disabled]="!isSiteAdmin">
            <div class="icon"><mat-icon class="tb-icon" svgIcon="tb:user-plus"></mat-icon></div>
            {{ "settings.account.navigation.users" | translate }}
          </a>
          <div class="with-new">
            <a
              href
              mat-menu-item
              (click)="emitCloseSideMenu()"
              [routerLink]="'/settings/activity-log'"
              class="mega-menu-navigation-item"
              [disabled]="!isSiteAdmin"
              [class.disabled]="!isSiteAdmin">
              <div class="icon"><span class="material-symbols-outlined">browse_activity</span></div>
              {{ "settings.account.navigation.activity-log" | translate }}
              @if (tierAccess?.isActivityLogAllowed === false) {
                <app-account-upgrade-tag></app-account-upgrade-tag>
              }
            </a>
          </div>
          <a
            href
            mat-menu-item
            [routerLink]="isSiteAdmin ? '/settings/apps' : null"
            class="mega-menu-navigation-item"
            [disabled]="!isSiteAdmin"
            [class.disabled]="!isSiteAdmin">
            <div class="icon"><mat-icon class="tb-icon" svgIcon="tb:puzzle-piece"></mat-icon></div>
            {{ "settings.account.navigation.apps-integration" | translate }}
          </a>
          <a
            href
            mat-menu-item
            (click)="emitCloseSideMenu()"
            [routerLink]="isSiteAdmin ? '/settings/plan-billing' : null"
            class="mega-menu-navigation-item"
            [disabled]="!isSiteAdmin"
            [class.disabled]="!isSiteAdmin">
            <div class="icon"><mat-icon class="tb-icon" svgIcon="tb:credit-card"></mat-icon></div>
            {{ "settings.account.navigation.upgrade" | translate }}
          </a>
        </div>
        <div class="learn-and-admin-menu">
          <div class="learn-menu">
            <h3>{{ "settings.account.navigation.learn-help" | translate }}</h3>
            <a href="https://help.triggerbee.com/" target="_blank" rel="noopener noreferrer" class="mega-menu-navigation-item" mat-menu-item>
              <div class="icon"><mat-icon class="tb-icon" svgIcon="tb:life-bouy"></mat-icon></div>
              {{ "settings.account.navigation.find-help" | translate }}
            </a>
            <a href mat-menu-item [routerLink]="['/knowledge/release-notes']" class="mega-menu-navigation-item" data-test="mega-menu-news">
              <div class="icon"><mat-icon class="tb-icon" svgIcon="tb:newspaper"></mat-icon></div>
              {{ "settings.account.navigation.news" | translate }}
            </a>
            <a href mat-menu-item [routerLink]="['/knowledge/feature-requests']" class="mega-menu-navigation-item" data-test="mega-menu-request-feature">
              <div class="icon"><mat-icon class="tb-icon" svgIcon="tb:bubble"></mat-icon></div>
              {{ "settings.account.navigation.request-feature" | translate }}
            </a>
          </div>
          @if (isAdmin) {
            <div class="admin-menu">
              <div class="admin-heading">
                <h3>{{ "settings.account.navigation.admin-only" | translate }}</h3>
                <span class="admin-only-tag"><mat-icon class="admin-only-tag-sub">font_download</mat-icon></span>
              </div>
              <div class="admin-content">
                <a href mat-menu-item [routerLink]="['/backoffice/campaigns/templates']" class="mega-menu-navigation-item">
                  <div class="icon"><mat-icon class="tb-icon" svgIcon="tb:view-compact"></mat-icon></div>
                  {{ "campaign.templates-title" | translate }}
                </a>
              </div>
              <div class="admin-content">
                <a href mat-menu-item [routerLink]="['/backoffice/email-templates']" class="mega-menu-navigation-item">
                  <div class="icon"><mat-icon class="tb-icon" svgIcon="tb:view-compact"></mat-icon></div>
                  {{ "email-templates.title" | translate }}
                </a>
              </div>
              <div class="admin-content">
                <a href mat-menu-item [routerLink]="['/backoffice/campaigns/filter-all']" class="mega-menu-navigation-item">
                  <div class="icon"><mat-icon class="tb-icon" svgIcon="tb:branding-watermark"></mat-icon></div>
                  {{ "campaign.filter-all" | translate }}
                </a>
              </div>
              <div class="admin-content">
                <a href mat-menu-item (click)="openBugReport($event)" class="mega-menu-navigation-item">
                  <div class="icon bug-report-icon"><mat-icon>bug_report</mat-icon></div>
                  {{ "account-admin.title.bugreports" | translate }}
                </a>
              </div>
              <div class="admin-content quick-settings">
                <div (click)="openAdminSettingsModal()" mat-menu-item class="mega-menu-navigation-item">
                  <div class="icon"><mat-icon class="material-icons-outlined">speed</mat-icon></div>
                  {{ "account-admin.title.quick-settings" | translate }}
                </div>
              </div>
              <div class="admin-content">
                <a href mat-menu-item [routerLink]="'/backoffice/status-page'" class="mega-menu-navigation-item">
                  <div class="icon status-page-icon"><mat-icon>monitor_heart</mat-icon></div>
                  {{ "account-admin.title.status-page" | translate }}
                </a>
              </div>
              <div class="admin-content">
                <a href mat-menu-item (click)="setUserBackOffice()" [routerLink]="'/backoffice'" class="mega-menu-navigation-item">
                  <div class="icon"><mat-icon class="tb-icon" svgIcon="tb:gears"></mat-icon></div>
                  {{ "account-admin.title.backoffice" | translate }}
                </a>
              </div>
            </div>
          }
        </div>
      </div>
      <div class="menu-footer">
        <!-- The mat-menu panel closes on any click inside it; keep the menu open when toggling theme. -->
        <app-theme-toggle (click)="$event.stopPropagation()"></app-theme-toggle>
        <div class="sign-out">
          <a href class="mega-menu-navigation-item reversed" data-test="mega-menu-sign-out" (click)="$event.preventDefault(); signOut()">
            {{ "settings.account.navigation.sign-out" | translate }}
            <div class="icon reversed"><mat-icon class="tb-icon" svgIcon="tb:sign-out"></mat-icon></div>
          </a>
        </div>
      </div>
    </mat-menu>
  </div>
}
